import React from "react";
import Header from "../../../Components/Header";
import SingleSignOnSideBar from "../../../Components/SingleSignOnSideBar";
import BankDetails from "../../../Components/PartnerAdminDashboardComp/partnerPersonalDeatilsComp/BankDetails"
import PersonalDetails from "../../../Components/PartnerAdminDashboardComp/partnerPersonalDeatilsComp/PersonalDetails"




function PersonalDetailsDashboard() {
  return (
    <>
      <Header  portal={"TELECALLER"} />
      <SingleSignOnSideBar/>
      <main id="main-content" className="personal-dashboard">
        <PersonalDetails />
        {/* <BankDetails /> */}
      </main>
    </>
  );
}

export default PersonalDetailsDashboard;
